import type { ReactNode, RefCallback } from 'react'
import styled from 'styled-components'

interface Props {
  activationRef: RefCallback<HTMLDivElement>
  children: ReactNode
}

const ActivationSentinel = styled.div`
  height: 1px;
  width: 100%;
  pointer-events: none;
`

/**
 * Fixed-height activation target shared by control and treatment.
 * Keep the IntersectionObserver ref on this sentinel so exposure is not
 * dependent on facilities content height, which differs by experiment arm.
 */
function StructuredFacilitiesReworkActivation({ activationRef, children }: Props) {
  return (
    <>
      <ActivationSentinel
        ref={activationRef}
        aria-hidden="true"
        data-testid="structured-facilities-rework-activation-sentinel"
      />
      {children}
    </>
  )
}

export function StructuredFacilitiesReworkStandaloneActivation({
  activationRef,
}: Pick<Props, 'activationRef'>) {
  return (
    <ActivationSentinel
      ref={activationRef}
      aria-hidden="true"
      data-testid="structured-facilities-rework-activation-sentinel"
    />
  )
}

export default StructuredFacilitiesReworkActivation
